import { render, staticRenderFns } from "./JianKang_progress.vue?vue&type=template&id=70fe6661&scoped=true"
import script from "./JianKang_progress.vue?vue&type=script&lang=js"
export * from "./JianKang_progress.vue?vue&type=script&lang=js"
import style0 from "./JianKang_progress.vue?vue&type=style&index=0&id=70fe6661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe6661",
  null
  
)

export default component.exports